<div class="pc-ms-filter" [class.pc-ms-filter--open]="dropdownOpen" [class.pc-ms-filter--light]="lightMode">
  <label class="pc-ms-filter__label" *ngIf="label">{{ label }}</label>

  <button
    #trigger
    type="button"
    class="pc-ms-filter__trigger"
    (click)="toggleDropdown($event)"
    [class.active]="dropdownOpen"
    [attr.aria-expanded]="dropdownOpen"
  >
    <span
      [class.pc-ms-filter__trigger-text--placeholder]="!selected.length"
      >{{ displayLabel }}</span
    >
    <mat-icon>keyboard_arrow_down</mat-icon>
  </button>

  <div
    *ngIf="dropdownOpen"
    #panel
    class="pc-ms-filter__panel"
    [class.pc-ms-filter__panel--light]="lightMode"
    (click)="$event.stopPropagation()"
  >
    <div class="pc-ms-filter__search">
      <mat-icon class="pc-ms-filter__search-icon">search</mat-icon>
      <input
        type="text"
        class="pc-ms-filter__search-input"
        [(ngModel)]="searchText"
        [ngModelOptions]="{ standalone: true }"
        [placeholder]="searchPlaceholder"
      />
    </div>

    <div class="pc-ms-filter__actions">
      <button type="button" class="pc-ms-filter__select-all" (click)="onSelectAllClick($event)">
        <span class="pc-ms-filter__checkbox" [class.pc-ms-filter__checkbox--checked]="isAllFilteredSelected()"></span>
        Select All
      </button>
      <button type="button" class="pc-ms-filter__clear" (click)="clearAll($event)">Clear All</button>
    </div>

    <div class="pc-ms-filter__options">
      <button
        type="button"
        *ngFor="let opt of filteredOptions; trackBy: trackOption"
        class="pc-ms-filter__option"
        (click)="onOptionClick($event, opt)"
      >
        <span class="pc-ms-filter__checkbox" [class.pc-ms-filter__checkbox--checked]="isSelected(opt.value)"></span>
        <span class="pc-ms-filter__option-label">{{ opt.label }}</span>
      </button>
      <div *ngIf="!filteredOptions.length" class="pc-ms-filter__empty">{{ emptyMessage }}</div>
    </div>
  </div>
</div>
